import Cookies from 'js-cookie'
import { jwtDecode } from "jwt-decode";
import React, { createContext, useState, useEffect, useContext } from "react";

export enum UserRoles {
  admin = 'admin',
  art = 'art',
  allUnauthed = 'allUnauthed',
  reviewer = "reviewer",
  dataScientist = "dataScientist"
}

interface userDetails {
  first: string,
  last: string,
  name: string,
  email: string,
  user_id: string
};

export interface AuthData {
  user_details: userDetails
  roles: UserRoles[]
  token: string,
  expiration: number,
  refresh_token: string,
};

export const AuthDataContext = createContext<ReturnType<typeof useAuthData>>(
  { user: null, onLogin: () => { }, onLogout: () => { } }
);

const useAuthData = () => {
  const [user, setUser] = useState<AuthData | null>(null);

  return {
    user, onLogin: (userData: AuthData) => { setUser(userData) }, onLogout: () => {
      console.log("Setting Auth");
      setUser(null);
      console.log("Removing Cookie");
      Cookies.remove('__session', { sameSite: 'Strict' });
    }
  }
};

export default function AuthDataProvider(props: any) {
  const authContext = useAuthData()
  const [isLoading, setIsLoading] = useState(true)

  /* The first time the component is rendered, it tries to
   * fetch the auth data from a source, like a cookie or
   * the localStorage.
   */
  useEffect(() => {
    const token = Cookies.get('__session') ? Cookies.get('__session') : null;
    if (token) {
      var decoded = jwtDecode<AuthData>(token);
      authContext.onLogin(decoded);
    }
    setIsLoading(false)
  }, []);

  return <AuthDataContext.Provider value={{...authContext, isLoading}} {...props} />;
};

export const useAuthDataContext = () => useContext(AuthDataContext);
